import { render, staticRenderFns } from "./transferSearch.vue?vue&type=template&id=50821364&scoped=true&"
import script from "./transferSearch.vue?vue&type=script&lang=ts&"
export * from "./transferSearch.vue?vue&type=script&lang=ts&"
import style0 from "./transferSearch.vue?vue&type=style&index=0&id=50821364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50821364",
  null
  
)

export default component.exports